import { forwardRef } from 'react';

import type { IconProps } from './types';

/*
 * DO NOT remove `forwardRef`
 * It is used for `motion.create`
 */
const MotiDepressed = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props} ref={forwardedRef}>
    <path
      d="M3.986 514.344C2.729 231.576 229.139 1.303 509.728.002l2.379-.001c279.456.017 506.642 227.693 507.906 509.649 1.258 282.772-225.149 513.043-505.713 514.344-101.83.466-196.793-29.287-276.523-80.902l-105.46 31.813c-32.035 9.658-61.972-20.242-52.679-52.614l28.576-99.513C43.282 737.214 4.509 630.373 3.985 514.342zm840.542 234.918c-5.546-217.399-173.495-268.368-333.151-266.961S181.912 537.912 180.351 750.31c-1.256 170.918 125.147 157.574 250.657 144.323 30.464-3.217 60.875-6.43 89.395-6.997 32.776-.655 67.451 2.967 101.455 6.52 117.483 12.269 226.972 23.705 222.671-144.893zm-335.286-221.26c124.287-2.232 273.199 40.782 276.738 206.146C788.768 864.379 690.04 855 592.809 845.766c-26.234-2.492-52.357-4.972-76.347-4.699-23.028.262-48.445 3.018-74.309 5.817-100.958 10.939-208.656 22.604-207-110.365 2.079-167.034 149.802-206.287 274.09-208.517zM399.488 804.594c34.898-7.304 57.364-41.994 50.184-77.478l-126.375 26.448c7.182 35.488 41.296 58.335 76.191 51.03zm300.593-51.028-126.373-26.451c-7.182 35.486 15.286 70.175 50.181 77.475 34.898 7.307 69.009-15.54 76.191-51.025z"
      fill={color}
    />
  </svg>
));

export default MotiDepressed;
